import React, {useState, useEffect, useRef} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Link } from 'react-router-dom';
import { Row, Col, Container, Card, CardBody, CardTitle, Modal, Form, Label, Input, Badge, UncontrolledDropdown } from "reactstrap"



import axios from 'axios';
import * as url from 'helpers/url_helper';
import * as be from 'helpers/backend_helper';
import { Config, TOAST_OPTIONS, formatDate } from 'helpers/backend_helper';
import toastr from "toastr";
import "toastr/build/toastr.min.css";

import { Button,  DropdownToggle,  DropdownMenu,  DropdownItem,  ButtonDropdown, Table} from "reactstrap";
import LoadingOverlay from 'react-loading-overlay';
import BounceLoader from 'react-spinners/BounceLoader'
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import { useHistory } from 'react-router-dom';

import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';

import paginationFactory, {
    PaginationListStandalone,
    PaginationProvider,
  } from "react-bootstrap-table2-paginator";

    const PerformanceAgreements = () => {
        
        const history = useHistory();
        toastr.options = TOAST_OPTIONS;
        const [isLoading, setIsLoading] = useState(false)
        const [deptList, setDeptList] = useState([])

        const [sStartDate, setSStartDate] = useState([new Date(new Date().getFullYear(), 0, 1)]);
        const [sEndDate, setSEndDate] = useState([new Date(new Date().getFullYear(), 11, 31)]);
        const [sEmployeeNo, setSEmployeeNo] = useState('') 
        const [sEmployeeName, setSEmployeeName] = useState('')  
        const [sDocumentNo, setSDocumentNo] = useState('')
        const [sDeptId, setSDeptId] = useState('')
        const [sLocationId, setSLocationId] = useState('')
        const [sStatus, setSStatus] = useState('')
        
        const [ipaList, setIPAList] = useState([])
        const [selectedEmployee, setSelectedEmployee] = useState('')
        const [documentNo, setDocumentNo] = useState('')
        const [employeeId, setEmployeeId] = useState('')
        const [appraisalPeriodId, setAppraisalPeriodId] = useState('')
        const [title, setTitle] = useState('')
        const [description, setDescription] = useState('')
        const [ipaId, setIPAId] = useState('')
        const [performanceYear, setPerformanceYear] = useState('')
        const [postingDate, setPostingDate] = useState([])
        const [convertToAppraisal, setConvertToAppraisal] = useState('No')
        const [ipaStatus, setIPAStatus] = useState('Open')
        const [supervisorId, setSupervisorId] = useState('')
        const [selectedSupervisor, setSelectedSupervisor] = useState('')
        const [supervisorComment, setSupervisorComment] = useState('')

        const [userId, setUserId] = useState('')
        const [isEdit, setIsEdit] = useState(false)

        const [department, setDepartment] = useState('')
        const [location, setLocation] = useState('')

       
        const [jobLocationOptions, setJobLocationOptions]     = useState([])
        const [appraisalPeriodOptions, setAppraisalPeriodOptions]     = useState([])
        const [statusOptions, setStatusOptions]     = useState(['Open', 'Pending Approval', 'Closed'])
        const [modal_ipa, setmodal_ipa] = useState(false);

        const [employeeOptions, setEmployeeOptions] = useState([])
        
        const removeBodyCss = () => {
          document.body.classList.add("no_padding");
        }
        const tog_ipa = () => {
          setmodal_ipa(!modal_ipa);
          removeBodyCss();
        }
        const fetchData = () => {
          axios.get(url.DEPTS, Config).then((r)=>{ setDeptList(r.data) }).catch((e)=>console.log(e))
          axios.post(url.HRPAPERIODS, JSON.stringify({action:'filter'}), Config).then((r)=>{ setAppraisalPeriodOptions(r.data) }).catch((e)=>console.log(e))
          axios.get(url.HRLOCATIONS, Config).then((r)=>{ setJobLocationOptions(r.data);  }).catch((e)=>{  console.log(e); });
          handleFilterData()
        }
        
        useEffect(() => {
          if (localStorage.getItem("authWTUser")) {
            const obj = JSON.parse(localStorage.getItem("authWTUser"));
            setUserId(obj.id);
          }
          const data = {
            id  : '',
            no  : '',
            nin : '',
            name: '',
            phone:'',
            sex : '',
            status:'',
            marital:'',
            dept: '',
            category: '',
            location: ''
           }
          setIsLoading(true)
          axios.post(`${url.HREMPLOYEESFILTER}`, JSON.stringify(data), Config).then((r)=>{ 
            let arr = [];
            (r.data || []).map((a)=>{
              arr.push({'value':a.id, 'label':a.name})
            })
            setEmployeeOptions(arr)
          }).catch((e)=>{  
            console.log(e); 
          }).finally(()=>{
            setIsLoading(false)
          });
          fetchData() 
        },[]);

        
        
        const handleFilterData = async () =>{
          try {
            const data = {
              startDate: formatDate(sStartDate),
              endDate: formatDate(sEndDate),
              documentNo: sDocumentNo,
              name: sEmployeeName,
              deptId: sDeptId,
              locationId: sLocationId,
              status : sStatus,
              employeeNo: sEmployeeNo,
              action:'filter'
            }
            setIsLoading(true)
            const r = await axios.post(url.HRPERFORMANCEAGG, JSON.stringify(data), Config)
            setIPAList(r.data)
          } catch (e) {
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }
        const handleClearSearch = () =>{
          setLeaveId('')
          setSStartDate([new Date()])
          setSEndDate([new Date()])
          setSEmployeeName('')
          setSEmployeeNo('')
          setSDocumentNo('')
          setSDeptId('')
          setSLocationId('')
          setSStatus('')
          handleFilterData()
        }

        const handleClickAdd = () =>{
          setIsEdit(false)
          setSelectedEmployee(null)
          setDocumentNo('')
          setAppraisalPeriodId('')
          setTitle('')
          setDescription('')
          setPerformanceYear('')
          setPostingDate([])
          setSelectedSupervisor(null)
          setSupervisorComment('')
          tog_ipa()
        }

        const handleSaveIPA = async () =>{
          const data = {
            employeeId: selectedEmployee.value,
            appraisalPeriodId: appraisalPeriodId,
            title: title,
            description: description,
            performanceYear: performanceYear,
            postingDate: formatDate(postingDate),
            convertToAppraisal: convertToAppraisal,
            supervisorComment: supervisorComment,
            status: ipaStatus,
            supervisorId: selectedSupervisor.value,
            action: 'add'
          }
          try {
            setIsLoading(true)
            const r = await axios.post(url.HRPERFORMANCEAGG, JSON.stringify(data), Config)
            if(r.data.status == "1"){
              toastr.success(r.data.message)
              history.push(`/performance-agreement-details/${be.encryptId(r.data.id)}`)
            }else{
              toastr.error(r.data.message)
            }
          } catch (e) {
            console.log(e)
          } finally {
            setIsLoading(false)
          }
        }


        const pageOptions = {
          sizePerPage: 10000,
          totalSize: ipaList.length,
          custom: true,
        }
        var node = useRef();
              
        const columns = [
        {
          dataField: 'document_no',
          text: 'No',
          sort: true
        },
        {
          dataField: 'appraisal_name',
          text: 'Period',
          sort: true
        },
        {
          dataField: 'first_name',
          text: 'Employee',
          sort: true,
          formatter: nameFormatter
        },
        {
          dataField: 'department',
          text: 'Department',
          sort: true
        },
        {
          dataField: 'location',
          text: 'Location',
          sort: true
        }, 

        {
          dataField: 'posting_date',
          text: 'Date Posted',
          sort: true
        }, 
        {
          dataField: 'supervisor_name',
          text: 'Supervisor',
          sort: true
        }, 
        {
          dataField: 'ipa_lines',
          text: 'PA Lines',
          sort: true,
          formatter: ipaLinesFormatter
        }, 
        {
          dataField: 'ipas_status',
          text: 'Status',
          sort: true,
          formatter: statusFormatter
        },
        {
          dataField: "action",
          isDummyField: true,
          text: "",
          formatter: actionFormatter
        }];

        const defaultSorted = [{
          dataField: 'dateTime',
          order: 'desc'
        }];
        function nameFormatter(cellContent, row){
          return(
            <div>{row.emp_title}{" "}{row.first_name}{" "}{row.surname}</div>
          )
        }
        function ipaLinesFormatter(cellContent, row){
          return(
            <div>{Array.isArray(row.ipa_lines) ? row.ipa_lines.length : 0}</div>
          )
        }
        function actionFormatter(cellContent, row){
          return(
            <Button
                  type="button"
                  color="info"
                  className="btn-sm btn-rounded"
                  onClick={()=>{ 
                      history.push(`/performance-agreement-details/${be.encryptId(row.ipas_id)}`)
                    }
                  }
                >
                  Details
            </Button>
          )
        }
        function statusFormatter(cellContent, row) {
          if (cellContent == "Closed") {
            return (
              <div>
                  <Badge className="me-2 bg-success">{ cellContent }</Badge>
              </div>
            );
          }else if(cellContent == "Pending Approval"){
            return (
              <div>
                  <Badge className="me-2 bg-warning">{cellContent}</Badge>
              </div>
            );
          }else{
            return (
              <div>
                  <Badge className="me-2 bg-dark">{ cellContent }</Badge>
              </div>
            );
          }
        }

        
        return (
            <>
              <LoadingOverlay
                active={isLoading}
                spinner={<BounceLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Performance Agreements | {url.COMPANY}</title>
                    </MetaTags>
                    <Container fluid={true}>

                                <Modal isOpen={modal_ipa} toggle={() => { tog_ipa(); }}  size="l" centered  backdrop={'static'}  >
                                <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`Update`:`Add`} Employee Performance Agreement</h5>
                                    <button type="button"  onClick={() => { setmodal_ipa(false);  }}  className="close" data-dismiss="modal"aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <Row>
                                      {isEdit && (
                                      <Col md={12}>
                                        <div className="mb-3">
                                            <label>Document No</label>
                                            <input className='form-control' type='text' defaultValue={documentNo} disabled={true}/>
                                        </div>
                                      </Col>
                                      )}
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Employee</label>
                                              <Select value={selectedEmployee} onChange={(oo)=>{setSelectedEmployee(oo);  }} options={employeeOptions} isSearchable/>
                                          </div>
                                      </Col>
                                      {isEdit && (
                                        <>
                                          <Col md={6}>
                                            <div className="mb-3">
                                                <label>Department</label>
                                                <input className='form-control' type='text' defaultValue={department} disabled={true}/>
                                            </div>
                                          </Col>
                                          <Col md={6}>
                                            <div className="mb-3">
                                                <label>Location</label>
                                                <input className='form-control' type='text' defaultValue={location} disabled={true}/>
                                            </div>
                                          </Col>
                                        </>
                                      )}
                                      <Col md={12}>
                                          <div className="mb-3">
                                              <label>Appraisal Period</label>
                                              <select className="form-select" value={appraisalPeriodId} onChange={(e)=>setAppraisalPeriodId(e.target.value)}>
                                              <option value=""></option>
                                                  {(appraisalPeriodOptions || []).map((d,k)=>(
                                                  <option key={k} value={d.id}>{d.name} - {d.status}</option>
                                                  ))}
                                              </select>
                                          </div>
                                      </Col>
                                      
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Title</label>
                                            <input className="form-control" type='text' value={title} onChange={(e)=>setTitle(e.target.value)} />
                                            
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Description</label>
                                            <input className="form-control" type='text' value={description} onChange={(e)=>setDescription(e.target.value)} />
                                            
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                          <div className="mb-3">
                                              <label>Performance Year</label>
                                              <input className="form-control" type='number' value={performanceYear} onChange={(e)=>setPerformanceYear(e.target.value)} />
                                          </div>
                                    </Col>
                                    <Col xl={12}>
                                        <div className="mb-3">
                                            <label>Posting Date</label>
                                            <Flatpickr
                                                className="form-control"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    enableTime: false
                                                }}
                                                value={postingDate}
                                                onChange={(dates)=>{setPostingDate(dates); }}
                                                />
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Convert to Appraisal</label>
                                            <select className="form-select" disabled={true} value={convertToAppraisal} onChange={(e)=>setConvertToAppraisal(e.target.value)} >
                                              <option value=""></option>
                                              <option value="No">No</option>
                                              <option value="Yes">Yes</option>
                                            </select>
                                            
                                        </div>
                                    </Col>
                                    <Col md={12}>
                                          <div className="mb-3">
                                              <label>Supervisor</label>
                                              <Select value={selectedSupervisor} onChange={(oo)=>{setSelectedSupervisor(oo);  }} options={employeeOptions} isSearchable/>
                                          </div>
                                    </Col>
                                    <Col md={12}>
                                        <div className="mb-3">
                                            <label>Status</label>
                                            <select className="form-select" disabled={true} value={ipaStatus} onChange={(e)=>setIPAStatus(e.target.value)} >
                                              <option value=""></option>
                                                  {(statusOptions || []).map((d,k)=>(
                                                  <option key={k} value={d}>{d}</option>
                                                  ))}
                                            </select>
                                            
                                        </div>
                                    </Col>
                                    </Row>
                                </div>
                                <div className="modal-footer">
                                {isLoading ? 
                                        (<button type="button" className="btn btn-secondary" disabled={true}>Please wait...</button>)
                                    : ( <button type="button" className="btn btn-success" onClick={handleSaveIPA} >Save...</button> )
                                }</div>
                                </Modal> 
                     
                        <Row>
                                      
                            <Col lg="12">
                            <Card>
                            <h5 className="card-header bg-transparent border-bottom text-uppercase">PERFOMANCE AGREEMENTS Filter</h5>
                                <CardBody>
                                <div>
                                    <Row className="mb-3">
                                    <Col xl={6} sm={6}>
                                        <div className="mt-2">
                                        <h5>{``}</h5>
                                        </div>
                                    </Col>

                                    
                                    </Row>
                                </div>
                                                <Row className="justify-content-center mb-1">
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>Start Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                    dateFormat: "Y-m-d",
                                                                    enableTime: false
                                                                }}
                                                                value={sStartDate}
                                                                onChange={(dates)=>{setSStartDate(dates); }}
                                                                />
                                                        </div>
                                                    </Col>
                                                    <Col xl={2}>
                                                        <div className="mb-3">
                                                            <label>End Date</label>
                                                            <Flatpickr
                                                                className="form-control form-control-sm"
                                                                options={{
                                                                    dateFormat: "Y-m-d",
                                                                    enableTime: false
                                                                }}
                                                                value={sEndDate}
                                                                onChange={(dates)=>{setSEndDate(dates); }}
                                                                />
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className="justify-content-center mb-2">
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Employee No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sEmployeeNo} onChange={(e)=>setSEmployeeNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Employee Name</label>
                                                          <input type='text' className="form-control form-control-sm" value={sEmployeeName} onChange={(e)=>setSEmployeeName(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Document No</label>
                                                          <input type='text' className="form-control form-control-sm" value={sDocumentNo} onChange={(e)=>setSDocumentNo(e.target.value)} />
                                                          
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Department</label>
                                                          <select className="form-select form-select-sm" value={sDeptId} onChange={(e)=>setSDeptId(e.target.value)}>
                                                          <option value="">All</option>
                                                             {(deptList || []).map((d,k)=>(
                                                              <option key={k} value={d.id}>{d.name}</option>
                                                             ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Location</label>
                                                          <select className="form-select form-select-sm" value={sLocationId} onChange={(e)=>setSLocationId(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(jobLocationOptions || []).map((d,k)=>(
                                                                <option key={k} value={d.id}>{d.name}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                                
                                                  <Col md={2}>
                                                      <div className="mb-3">
                                                          <label>Status</label>
                                                          <select className="form-select form-select-sm" value={sStatus} onChange={(e)=>setSStatus(e.target.value)}>
                                                              <option value="">All</option>
                                                              {(statusOptions || []).map((e,k)=>(
                                                                <option value={e} key={k}>{e}</option>
                                                              ))}
                                                          </select>
                                                      </div>
                                                  </Col>
                                          
                                                </Row>
                                                <Row  className="justify-content-center mb-2">
                                                <Col lg={2} className='mb-2'> 
                                                  <div className="d-grid gap-2">
                                                      <Button
                                                        color='primary'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleFilterData()}}
                                                      >
                                                        <i className="mdi mdi-magnify me-1" />
                                                        Search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='warning'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClearSearch()}}
                                                      >
                                                        <i className="mdi mdi-notification-clear-all me-1" />
                                                        Reset search
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                  <Col lg={2} className='mb-2'> 
                                                    <div className="d-grid gap-2">
                                                      <Button
                                                        color='success'
                                                        className="btn btn-sm"
                                                        onClick={()=>{handleClickAdd()}}
                                                        
                                                      >
                                                        <i className="mdi mdi-plus me-1" />
                                                        Add Agreement
                                                      </Button>
                                                    </div>
                                                  </Col>
                                                </Row>
                                                </CardBody>
                                                </Card>
                                                <Card>
                                                <h5 className="card-header bg-transparent border-bottom text-uppercase">PERFOMANCE AGREEMENTS ({ipaList.length})</h5>
                                                  <CardBody>

                                                                                             
                                {(ipaList.length > 0) && (
                                    <PaginationProvider
                                    pagination={paginationFactory(pageOptions)}
                                    keyField="ipas_id"
                                    columns={columns}
                                    data={ipaList}
                                    >
                                    {({ paginationProps, paginationTableProps }) => (
                                    <ToolkitProvider
                                      keyField="ipas_id"
                                      data={ ipaList }
                                      columns={ columns }
                                    >
                                      { toolkitProps => (
                                          <React.Fragment>
                              
                                            <Row>
                                              <Col xl="12">
                                                
                                              <div className="table-responsive">
                                                <BootstrapTable 
                                                  
                                                  keyField='ipas_id' 
                                                  data={ ipaList } 
                                                  columns={ columns } 
                                                  striped
                                                  hover
                                                  condensed
                                                  bordered={ false }
                                                  noDataIndication="No Records" 
                                                  defaultSorted={ defaultSorted }
                                                  classes={ "table table-sm align-middle table-nowrap table-check" }
                                                  style={{ backgroundColor: 'white' }}
                                                    {...toolkitProps.baseProps}
                                                    {...paginationTableProps}
                                                  ref={node}
                                                  />
                                                  </div>
                                            
                                            </Col>
                                            </Row>
                                            <Row className="align-items-md-center mt-30">
                                              <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                                                <PaginationListStandalone
                                                  {...paginationProps}
                                                />
                                              </Col>
                                            </Row>
                                            </React.Fragment>
                                            
                                      )
                                    }
                                    </ToolkitProvider>
                                    )}
                                    </PaginationProvider>
                                    )}
                                    {((ipaList || []).length < 1) && (
                                    <div className="text-center">
                                      <div className="mb-4">
                                      <i className="mdi mdi-flask-empty-minus-outline text-danger display-4" />
                                      </div>
                                      <div>
                                      { isLoading ? <h5>Please Wait...</h5> : <h5>No data</h5> }
                                      <p className="text-muted">
                                              
                                      </p>
                                      </div>
                                      <div className="text-center mt-4">
                                        <Link
                                        to="#"
                                        onClick={()=>{handleClickAdd()}}
                                       
                                        className="btn btn-primary  btn-sm"
                                        >
                                        Create Employee Performance Agreement <i className="mdi mdi-arrow-right ms-1" />
                                        </Link>
                                    </div>
                                    </div>
                                    

                                    )}


                                </CardBody>
                            </Card>
                            </Col>

                           
                        </Row>

                        
                           

                    </Container>
                </div>
                </LoadingOverlay>
            </>
        );
    }

export default PerformanceAgreements;